import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type ContractEvents =
  | 'DELETE_FROM_TABLE'
  | 'DELETE_FROM_DETAILS'
  | 'ACTION_SELECTION'
  | 'CONTRACT_TOOLBAR_ADD_CONTRACT'
  | 'CONTRACT_HUB_START_SEARCH_BAR'
  | 'CONTRACT_SELECT_NEW_ADD_CONTRACT_BUTTON'
  | 'CONTRACT_CLICK_EXPORT_CSV_BUTTON'
  | 'CONTRACT_CLICK_IMPORT_BUTTON'
  | 'CONTRACT_CLICK_EXPORT_EXCEL_BUTTON'
  | 'CONTRACT_CLICK_EXPORT_DROPDOWN_BUTTON'
  | 'CONTRACT_FILTER_CONTRACTING_PARTY'
  | 'CONTRACT_FILTER_TYPE'
  | 'CONTRACT_DETAILS_TABS_CLICK'
  | 'CONTRACT_FILTER_STATUS'
  | 'CONTRACT_FILTER_BUTTON'
  | 'CONTRACT_FILTER_PARENT_CONTRACT'
  | 'CONTRACT_HUB_CLICK_CONTRACT_TITLE'
  | 'CONTRACT_HUB_CLICK_CONTRACT_REQUESTOR'
  | 'CONTRACT_HUB_CLICK_CONTRACT_PARENT_CONTRACT'
  | 'CONTRACT_HUB_CLICK_CONTRACT_ENGAGEMENT'
  | 'CONTRACT_HUB_CLICK_CONTRACT_CONTRACTING_PARTY'
  | 'CONTRACT_DETAILS_DETAILS_TAB'
  | 'CONTRACT_DETAILS_ENGAGEMENTS_TAB'
  | 'CONTRACT_DETAILS_MILESTONES_TAB'
  | 'CONTRACT_DETAILS_PROCESSES_TAB'
  | 'CONTRACT_DETAILS_CLICK_DOWNLOAD_DOCUMENT'
  | 'CONTRACT_ENGAGEMENT_CLICK_VIEW_WORKER_PROFILE'
  | 'CONTRACT_DETAILS_CLICK_MILESTONES_EXPAND_PANEL'
  | 'CONTRACT_CLICK_PROCESS_ENTITY_DESCRIPTOR'
  | 'CONTRACT_HUB_CLICK_DELETE_CONTRACT_OVERFLOW_ACTION'
  | 'CONTRACT_HUB_CLICK_EDIT_PROCESS_OVERFLOW_ACTION'
  | 'CONTRACT_HUB_CLICK_CHANGE_HISTORY_OVERFLOW_ACTION'
  | 'EXPORT_CONTRACT_RESULT';

export const contract: Record<ContractEvents, MixpanelEvent> = {
  DELETE_FROM_TABLE: {
    eventDescription: 'Delete Contract (Table)',
    eventKey: 'contract-delete-table',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  DELETE_FROM_DETAILS: {
    eventDescription: 'Delete Contract (Details)',
    eventKey: 'contract-delete-details',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  ACTION_SELECTION: {
    eventKey: 'contract-hub-action_selection',
    eventDescription: 'User selected action from the overflow menu',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  CONTRACT_HUB_CLICK_CONTRACT_TITLE: {
    eventKey: 'contract-hub-click-contract-title',
    eventDescription: 'User clicks contract title in contract hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  CONTRACT_HUB_CLICK_CONTRACT_PARENT_CONTRACT: {
    eventKey: 'contract-hub-click-contract-parent-contract',
    eventDescription: 'User clicks contract parent contract in contract hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  CONTRACT_HUB_CLICK_CONTRACT_ENGAGEMENT: {
    eventKey: 'contract-hub-click-contract-engagement',
    eventDescription: 'User clicks contract engagement in contract hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  CONTRACT_HUB_CLICK_CONTRACT_CONTRACTING_PARTY: {
    eventKey: 'contract-hub-click-contract-contracting-party',
    eventDescription: 'User clicks contract parent contracting party in contract hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  CONTRACT_HUB_CLICK_CONTRACT_REQUESTOR: {
    eventKey: 'contract-hub-click-contract-requestor',
    eventDescription: 'User clicks contract requestor in contract hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  CONTRACT_TOOLBAR_ADD_CONTRACT: {
    eventKey: 'contract-hub-toolbar-add-contract',
    eventDescription: 'User clicks add contract from contract hub toolbar',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_TOOLBAR_BUTTON
  },
  CONTRACT_HUB_START_SEARCH_BAR: {
    eventKey: 'contract-hub-click-search-bar-and-starts-search',
    eventDescription: 'User clicks search bar in contracts hub and starts search',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  CONTRACT_SELECT_NEW_ADD_CONTRACT_BUTTON: {
    eventKey: 'contract-click-add-new-contract-select',
    eventDescription: 'User clicks select button to add new contract and start page flow',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_CLICK_EXPORT_DROPDOWN_BUTTON: {
    eventKey: 'contract-click-export-dropdown-button',
    eventDescription: 'User clicks export to dropdown button in contracts hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_CLICK_EXPORT_EXCEL_BUTTON: {
    eventKey: 'contract-click-export-excel-button',
    eventDescription: 'User clicks export to excel button in contracts hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_CLICK_EXPORT_CSV_BUTTON: {
    eventKey: 'contract-click-export-csv-button',
    eventDescription: 'User clicks export to csv button in contracts hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_CLICK_IMPORT_BUTTON: {
    eventKey: 'contract-click-import-button',
    eventDescription: 'User clicks import button in contracts hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_FILTER_BUTTON: {
    eventKey: 'contract-click-toolbar-filter-button',
    eventDescription: 'User clicks toolbar filter button in contracts hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_FILTER_STATUS: {
    eventKey: 'contract-click-filter-status-select',
    eventDescription: 'User clicks contract filter status input',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_FILTER_TYPE: {
    eventKey: 'contract-click-filter-type-select',
    eventDescription: 'User clicks contract filter type option',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_FILTER_PARENT_CONTRACT: {
    eventKey: 'contract-click-filter-parent-contract-select',
    eventDescription: 'User clicks contract filter parent contract input',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_FILTER_CONTRACTING_PARTY: {
    eventKey: 'contract-click-filter-contracting-party-select',
    eventDescription: 'User clicks contract filter contracting party input',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_DETAILS_DETAILS_TAB: {
    eventKey: 'contract-details-page-view-details',
    eventDescription: 'User views contract details tab in contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_DETAILS_ENGAGEMENTS_TAB: {
    eventKey: 'contract-details-page-view-engagements',
    eventDescription: 'User views contract engagements tab in contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_DETAILS_TABS_CLICK: {
    eventKey: 'contract-details-tabs-click',
    eventDescription: 'contract details tabs click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  CONTRACT_DETAILS_MILESTONES_TAB: {
    eventKey: 'contract-details-page-view-milestones',
    eventDescription: 'User views contract milestones tab in contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_DETAILS_PROCESSES_TAB: {
    eventKey: 'contract-details-page-view-processes',
    eventDescription: 'User views contract processes tab in contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_DETAILS_CLICK_DOWNLOAD_DOCUMENT: {
    eventKey: 'contract-details-page-user-click-download-doc',
    eventDescription: 'User downloads doc on contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_ENGAGEMENT_CLICK_VIEW_WORKER_PROFILE: {
    eventKey: 'contract-details-page-engagement-user-click-view-worker-profile',
    eventDescription: 'User clicks view worker profile in engagement tab in contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_DETAILS_CLICK_MILESTONES_EXPAND_PANEL: {
    eventKey: 'contract-details-page-milestones-user-click-expand-milestone-card',
    eventDescription: 'User clicks expand milestone card in milestones tab in contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_CLICK_PROCESS_ENTITY_DESCRIPTOR: {
    eventKey: 'contract-details-page-processes-user-click-entity-descriptor',
    eventDescription: 'User clicks entity descriptor in processes tab in contract details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_HUB_CLICK_DELETE_CONTRACT_OVERFLOW_ACTION: {
    eventKey: 'contract-hub-user-click-delete-contract',
    eventDescription: 'User clicks delete contract overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_HUB_CLICK_EDIT_PROCESS_OVERFLOW_ACTION: {
    eventKey: 'contract-hub-user-click-edit-contract',
    eventDescription: 'User clicks edit contract overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  CONTRACT_HUB_CLICK_CHANGE_HISTORY_OVERFLOW_ACTION: {
    eventKey: 'contract-hub-user-click-view-contract-change-history',
    eventDescription: 'User clicks view contract change history overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  EXPORT_CONTRACT_RESULT: {
    eventKey: 'click-contract-quick-report-export',
    eventDescription: 'User clicks contract quick report export',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  }
} as const;
